export default __webpack_public_path__ + "static/media/ic-download.02bf8a8f.svg";